import { render, staticRenderFns } from "./deleteResourceBtn.vue?vue&type=template&id=45281812&scoped=true&"
import script from "./deleteResourceBtn.vue?vue&type=script&lang=js&"
export * from "./deleteResourceBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45281812",
  null
  
)

export default component.exports